module.exports = __webpack_public_path__ + "media/95.5a5b7573.mp3";